let ALERTMESSAGES: any = {};

ALERTMESSAGES = {
   LeadInsertSuccess:"Lead added successfully.",
   Registration:"User register successfully.",
   Registration_Info:"User register successfully, We will verify your school and get back to you.",
   DEFAULT:"Something went wrong...",
   VERIFYEMAIL:"Welcome to LoneStar. You are almost ready to stop grading papers and to start your Revolution! We sent you an email, please check your email and click the verify email link we sent. Check your spam folder if you do not find the email.",
   EMAILEXTENSIONERROR:"Please enter a valid school email address. If you believe this is a mistake, contact us at hi@cleark12.com for assistance. Thank you.",
   FORMSUBMMITED: "Form Submitted Successfully."
}
export default ALERTMESSAGES;